export default {
    styleOverrides: {
        root: {
            height: "4em",
            width: "4em",
        },
    },
};
